"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var icons_1 = require("@tiendanube/icons");
function Item(_a) {
    var src = _a.src, onDelete = _a.onDelete, altText = _a.altText, skeleton = _a.skeleton;
    return (React.createElement("div", { className: "nimbus--image-gallery-item__wrapper" },
        React.createElement("div", { className: "nimbus--image-gallery-item" }, skeleton ? (React.createElement("div", { className: "nimbus--image-gallery-skeleton__wrapper" },
            React.createElement("div", { className: "nimbus--image-gallery-skeleton" }))) : (React.createElement(React.Fragment, null,
            React.createElement("img", { src: src, alt: altText, className: "nimbus--image-gallery-item__image" }),
            React.createElement("button", { "aria-label": "Delete image", type: "button", onClick: onDelete, className: "nimbus--image-gallery-item__delete" },
                React.createElement("span", { className: "nimbus--image-gallery-item__delete-button" },
                    React.createElement(icons_1.TrashIcon, null))))))));
}
exports.default = Item;
//# sourceMappingURL=ImageGallery.Item.js.map